export enum PromptPrefix {
  ARE_SURE = 'Are you sure you want to',
}
